import React, { FC } from "react"
import { Link } from "gatsby"
import LoadingIcon from "@icons/loadingIcon"
import type { ButtonProps } from "./types"
import { IconButton, IconWrapper, PlainButton } from "./styles"

const Button: FC<ButtonProps> = ({
    iconLeft,
    iconRight,
    isLoading,
    icon,
    type = "button",
    children,
    ...props
}) => {
    const buttonContent = <>
        {iconLeft && <IconWrapper icon="left">{iconLeft}</IconWrapper>}
        {children}
        {iconRight && <IconWrapper icon="right">{iconRight}</IconWrapper>}
        {isLoading && <IconWrapper icon="loading">
            <LoadingIcon />
        </IconWrapper>}
    </>

    if (props.link) {
        const isExternal = props.link?.startsWith("http") || props.link?.startsWith("//")

        if (isExternal) {
            if (icon) {
                return <IconButton
                    as="a"
                    {...props}
                >
                    {icon}
                </IconButton>
            }
            return <PlainButton
                as="a"
                type={type}
                {...props}
            >
                {buttonContent}
            </PlainButton>
        }
        if (icon) {
            return <IconButton
                as={Link}
                to={props.link}
                {...props}
            >
                {icon}
            </IconButton>
        }
        return <PlainButton
            as={Link}
            to={props.link}
            {...props}
        >
            {buttonContent}
        </PlainButton>
    }

    if (icon) {
        return <IconButton
            type={type}
            {...props}
        >
            {icon}
        </IconButton>
    }

    return <PlainButton
        type={type}
        {...props}
    >
        {buttonContent}
    </PlainButton>
}

export default Button
